import { render, staticRenderFns } from "./PamTrocaTurma.vue?vue&type=template&id=0d8cd16e&scoped=true&"
import script from "./PamTrocaTurma.vue?vue&type=script&lang=js&"
export * from "./PamTrocaTurma.vue?vue&type=script&lang=js&"
import style0 from "./PamTrocaTurma.vue?vue&type=style&index=0&id=0d8cd16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8cd16e",
  null
  
)

export default component.exports